import {AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import * as chart from 'chart.js';
import {Logger} from "@common-lib";
import {
    AnalyticsData, AnalyticsDataItem, AnalyticsDataLabels,
    TimeInterval
} from "../../services/analytics-dashboard.service";
import * as moment from "moment";
import {TranslateService} from "@ngx-translate/core";

const Chart = chart.Chart;

@Component({
    selector: 'app-dashboard-chart-pane',
    templateUrl: './dashboard-chart-pane.component.html',
    styleUrls: ['./dashboard-chart-pane.component.scss']
})
export class DashboardChartPaneComponent implements OnInit, OnChanges, AfterViewInit {

    @Input()
    data: AnalyticsData;

    @Input()
    partition: string;

    @Input()
    title: string;

    @Input()
    interval: TimeInterval;

    private chart: Chart = null;

    @ViewChild('canvas')
    canvas: ElementRef;

    constructor(private el: ElementRef, private logger: Logger, private translationService: TranslateService) {
    }

    ngOnInit() {
    }


    async ngOnChanges(changes: SimpleChanges) {
        if ((changes.data !== undefined && changes.data.currentValue) ||
            (changes.partition !== undefined && changes.partition.currentValue && this.data !== undefined)) {

            let stream: AnalyticsData = (this.data || changes.data.currentValue) as AnalyticsData;
            let partition: AnalyticsDataItem = this.getValue(this.partition, stream) as AnalyticsDataItem;
            await this.updateData(partition);
        }
        if (this.chart) {
            this.chart.update();
        }
    }

    private async updateData(partition: AnalyticsDataItem) {
        if (partition) {
            let ctx = this.canvas.nativeElement.getContext('2d');
            let data: AnalyticsDataItem = partition;
            let label = await (this.translationService.get(partition.label).toPromise());
            let gradientFill = ctx.createLinearGradient(0, 0, 0, 300);
            gradientFill.addColorStop(0, "rgba(31, 160, 255, 0.7)");
            gradientFill.addColorStop(1, "rgba(31, 160, 255, 0.0)");
            let lineChartData = {
                labels: this.generateLabels(data),
                datasets: [
                    {
                        label: label,
                        backgroundColor: gradientFill,
                        lineTension: 0,
                        borderColor: "rgba(31, 160, 255, 1.0)",
                        borderWidth: 1,
                        pointRadius: 2,
                        pointBackgroundColor: "rgba(31, 160, 255, 1.0)",
                        pointBorderColor: "rgba(31, 160, 255, 1.0)",
                        pointHighlightFill: "#fff",
                        pointHighlightStroke: "rgba(31, 160, 255, 1.0)",
                        data: data.data.map((v) => ({x: v.date, y: v.amount}))
                    }
                ]

            };
            if (this.chart !== null) {
                this.chart.destroy();
            }
            let opts: any = {
                responsive: true,
                title: {
                    display: false
                }
            };
            if(this.interval === TimeInterval.RealTime){
                opts.animation = false;
            }
            this.chart = new chart.Chart(ctx, {
                type: 'line',
                data: lineChartData,
                options: opts
            });
        }
    }

    private generateLabels(data: AnalyticsDataItem) {
        let labels = [];
        let format = 'MMM Do HH';
        switch (this.interval) {
            case TimeInterval.Hour:
                format = 'MMM Do HH:mm';
                break;
            case TimeInterval.Day:
                format = 'MMM Do HH';
                break;
            case TimeInterval.Week:
                format = 'MMM Do YY';
                break;
            case TimeInterval.Month:
                format = 'MMM Do YY';
                break;
            case TimeInterval.Year:
                format = 'MMM YY';
                break;
        }

        for (let i = 0; i < data.data.length; i++) {
            let item = data.data[i];
            labels.push(moment(item.date, 'YYYY-MM-DD HH:mm:ss').format(format));
        }

        return labels;
    }

    private getValue(key: string, json: Object): any {
        return key.split('.').reduce((o, i) => o[i], json);
    }

    getContainerWidth() {
        let style = window.getComputedStyle(this.el.nativeElement.parentElement);
        return Number.parseInt(style.getPropertyValue('width'));
    }

    getContainerHeight() {
        return 400;
    }


    ngAfterViewInit(): void {

    }


}



// WEBPACK FOOTER //
// ./src/app/components/dashboard-chart-pane/dashboard-chart-pane.component.ts